import React__default from 'react';
import { i as img } from '../../../../PF-icon-4757955a.js';

var InfoBlockImg = function (_a) {
    var _b = _a.imageSrc, imageSrc = _b === void 0 ? img : _b, _c = _a.alt, alt = _c === void 0 ? '' : _c;
    return React__default.createElement("img", { className: 'checked-img', src: imageSrc, alt: alt });
};

export { InfoBlockImg };
